import api from "../API/API";
import {Housemate} from "../Types/Housemate";

export function getAuthToken(): string {
    return localStorage.getItem("app_jwt") ?? "";
}

export async function getMe(): Promise<Housemate> {
    try {
        const res = await api.get("/api/user/get/me");
        return res.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}